<style scoped>
    @import url("../../../styles/smartControl/grafIrrig.scss");
</style>

<template>
    <div class="box_grafIrrig"
    :style="{'min-height':novaAltura, 'width':novaLargura}"
    >
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <div class="boxTitGraf" v-if="!flagLoading">

            <!-- ICONES DE CONTROLE DO GRAFICO -->
            <div class="box_icons" v-if="!flagLoading">

                <!--<v-icon 
                class="refreshGraf"
                @mouseover="backColorHelp = '#EA9611'"
                @mouseleave="backColorHelp = ''"
                :style="{'color':backColorHelp}"
                >
                    mdi-help-circle-outline

                    <v-tooltip activator="parent" location="top">
                        Texto explicativo aqui
                    </v-tooltip>
                </v-icon>-->

                <v-tooltip 
                text="Horário da irrigação aproximado pela leitura mais próxima do sensor." 
                location="top"
                class="refreshGraf"
                >
                    <template v-slot:activator="{ props }">
                        <v-icon 
                        v-bind="props" 
                        size="20"
                        @mouseover="backColorHelp = '#EA9611'"
                        @mouseleave="backColorHelp = ''"
                        :style="{'color':backColorHelp}"
                        >
                            mdi-help-circle-outline
                        </v-icon>
                    </template>
                </v-tooltip>

            </div>

            <span class="titGraf">{{ main_tit }}</span>
            <!-- <v-icon v-if="!flagBTN">mdi-image-refresh-outline</v-icon> -->

            <!-- ICONES DE CONTROLE DO GRAFICO-->
            <div class="box_icons" v-if="!flagLoading">

                <v-icon 
                @click="plotTesteBarra()" 
                class="refreshGraf"
                @mouseover="backColorRefresh = '#EA9611'"
                @mouseleave="backColorRefresh = ''"
                :style="{'color':backColorRefresh}"
                >
                    mdi-refresh-circle
                </v-icon>

            </div>
        </div>

        <!--  -->
        <div class="semDadosGraf" v-if="!flagApex && !flagLoading">
            <v-icon size="42">mdi-emoticon-sad-outline</v-icon>
            <div>AINDA NÃO HÁ DADOS</div>
        </div>

        <!--  v-if="!flagBTN && !flagLoading && flagApex" -->
        <apexchart v-if="!flagLoading && flagApex" 
        class="ajusteApexGraf" 
        :key="chartKey" 
        ref="chartA" 
        :series="series" 
        :options="options"
        :height="alturaGrafico"
        ></apexchart>
        
    </div>
</template>

<script>
import axios from 'axios'
import { convFromUtc } from "../auxSC/timeConv.js"; // criado em 04/05/2026
import { bus } from "../auxSC/eventBus"; // 14/06/2026

export default {

    props:['key_a','key_b','tit_a','tit_b','device_id_a','device_id_b','device_id_c','main_tit','target_fc','flag_show_all'],

    data() {
        return {
            liExib:[], // value
            labelsDatas:[], // date

            liExibSUB:[], // value --> listas associadas a lista principal.
            labelsDatasSUB:[], // date

            flagLoading:true, // init loading...
            //flagLoading:null, // init null (loading é habilitado na func)
            flagBTN:true,
            backColorRefresh:'',
            backColorHelp:'',

            // controle de tamanho da pagina
            novaLargura:'250px',
            novaAltura:'150px',
            alturaGrafico:'150px',

            flagApex:true, // inicia ok
            chartKey: 0, // chave de atualização apex chart
            series: [
                {
                    name: 'Entrada',
                    type: 'column',
                    //data: [18, 20, 22, 20, 16, 15],
                    data: [0, 0, 0, 2, 0, 4]
                },
                /*{
                    name: 'Sensor associado',
                    type: 'line',
                    data: [0, 0, 0, 0, 0, 0],
                    dashArray: 5  // Define a linha como pontilhada
                }*/
            ],
            options:{
                chart: {
                    type: 'line',
                    toolbar: {
                        show: false  // Desativa o menu (toolbar)
                    },
                    //width: '280px' // Pode ser um valor em pixels (px) ou percentual (%)
                },
                stroke: {
                    //width: 1.5, // grossura da linha (para o caso sem sensor associado)
                    width: [0, 5], // intervalo de grossura da coluna (bom resultado)
                    //dashArray: 5 // 1(graf 1 pontilhado) | 2(graf 2 pontilhado) | 3(pontilhado grosso nos 2 graf) | 4
                    //dashArray: [0, 2]  // Faz a segunda série (linha) ser pontilhada
                },
                //stroke: {width:2, dashArray:0},
                //labels: ['', '', '', '', '', ''],
                yaxis: { 
                    labels: {
                        formatter: function (value) {
                            return value.toFixed(2); // 2 casas decimais
                        }
                    }
                },
                xaxis: {
                    //categories: this.labelsDatas, // inicia vazio?
                    //type: 'datetime',
                    type: 'category',
                    categories: this.labelsDatas,
                    labels: { show: false },
                    /*axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    }*/
                },
                tooltip: {
                    y: {
                        formatter: function (value) {
                            return value.toFixed(2); // Limita a 2 casas decimais
                        }
                    },
                    x: {
                        //format: 'dd/MM/yyyy HH:mm' // se forem datas
                        format: 'dd/MM/yyyy' // ou 'dd MMM yyyy', etc.
                    },
                },
            },
        }
    },

    methods:{

        dtToStr(dt) {

            const dd = String(dt.getUTCDate()).padStart(2, '0')
            const mm = String(dt.getUTCMonth() + 1).padStart(2, '0')
            const yyyy = dt.getUTCFullYear()

            const hh = String(dt.getUTCHours()).padStart(2, '0')
            const min = String(dt.getUTCMinutes()).padStart(2, '0')

            return `${dd}/${mm}/${yyyy}-${hh}:${min}`
        },

        parseDtLocal(dtStr) {
            const [data, hora] = dtStr.split('-')
            const [dd, mm, yyyy] = data.split('/').map(Number)
            const [hh, min] = hora.split(':').map(Number)

            return new Date(yyyy, mm - 1, dd, hh, min)
        },

        montar_lista_scatter(eventosScatter, histIrrigDT, histDT) {

            const maxDifMin = 15

            let c = 0
            while (c < histIrrigDT.length) {

                const eventoData = histIrrigDT[c]
                const eventoDate = this.parseDtLocal(eventoData)

                let melhorIndex = -1
                let menorDifMs = Infinity

                let i = 0
                while (i < histDT.length) {

                    const histDate = this.parseDtLocal(histDT[i])
                    const difMs = Math.abs(histDate - eventoDate)

                    if (difMs < menorDifMs) {
                        menorDifMs = difMs
                        melhorIndex = i
                    }

                    i++
                }

                const menorDifMin = menorDifMs / (1000 * 60)

                if (melhorIndex !== -1 && menorDifMin <= maxDifMin) {

                    //console.log('--------------------------------')
                    //console.log('Evento irrigação:', eventoData)
                    //console.log('Uplink escolhido:', histDT[melhorIndex])
                    //console.log('Dif (min):', menorDifMin)
                    
                    eventosScatter[melhorIndex] = 0
                }

                c++
            }
            return eventosScatter
        },

        async plotTesteBarra() {

            this.flagLoading = true

            const tzName = this.$store.state.fusoHorarioSC // esperado algo como --> "Europe/Lisbon"

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }
            
            // -- intervalor pre-definido: agora - 48h
            const dtNow = new Date() // agora UTC
            const dt72h = new Date(dtNow.getTime() - (72 * 60 * 60 * 1000)) // 48h atrás
            //console.log('dtNowStr:', this.dtToStr(dtNow))
            //console.log('dt48hStr:', this.dtToStr(dt72h))

            //console.log('(1)')
            let device_id = ''
            if (this.$store.state.sistemaSC == 'upinc1') { device_id = this.device_id_a }
            if (this.$store.state.sistemaSC == 'invernadero1000derecho') { device_id = this.device_id_b }
            if (this.$store.state.sistemaSC == 'upinc4') { device_id = this.device_id_c }
            if (device_id == '') {

                this.flagApex = false // não exibir o gráfico (mensagem de erro)
                this.flagLoading = false
                console.log('device id nao encontrado')
                return
            }
            //console.log('(2)')

            let params = { 
                'cliente':this.$store.state.emailCliente, 
                'sistema':this.$store.state.sistemaSC, 
                'range_init':this.dtToStr(dt72h), // '30/05/2026-04:00' <-- (+antigo)
                'range_end':this.dtToStr(dtNow), // '02/06/2026-18:00' <-- (+recente)
                'device_id':device_id
            }

            const url = this.$store.state.pathAxiosBASE + '/xhistirrig'

            let histRangeRcv = []
            const res = await axios.post(url, params, {headers})
            //console.log('res: ',res.data.result)
            if (res.data.result.ok) { histRangeRcv = res.data.result.hist } 
            else { 

                this.flagApex = false // não exibir o gráfico (mensagem de erro)
                this.flagLoading = false
            }

            if (histRangeRcv.length == 0) {

                this.flagApex = false // não exibir o gráfico (mensagem de erro)
                this.flagLoading = false
                console.log('lista vazia')
                return
            }

            // buscar hist irrig
            const url_b = this.$store.state.pathAxiosBASE + '/xhistirrigxok'
            let flagRangeIrrig = false
            let histRangeIrrig = []
            let histIrrigDT = []
            const res_b = await axios.post(url_b, params, {headers}) // mesmo device_id
            //console.log('res_b: ',res_b)
            if (res_b.data.result.ok) { 

                histRangeIrrig = res_b.data.result.hist
                //console.log(histRangeIrrig)

                const datasVistas = new Set()

                let resConvDT_b = null

                for (const el of histRangeIrrig) {

                    //const dt = el.utc_irrig_ok
                    //const dt = new Date(el.utc_irrig_ok.replace(' ', 'T') + 'Z')
                    // DEBUG ABAIXO:
                    //const dtStr = el.utc_irrig_ok.replace(' ', 'T') + 'Z' // <-- 'Z' == +00:00 que pode já existir
                    //const dt = new Date(dtStr)

                    const dt = new Date(el.utc_irrig_ok)

                    if (isNaN(dt.getTime())) {
                        console.log('[ERRO] Datetime inválido:', el.utc_irrig_ok)
                        console.log('[ERRO] Registro:', el)
                        continue
                    }

                    //if (datasVistas.has(dt)) { // evitar repetir mesmo utc
                    if (datasVistas.has(dt.getTime())) { 
                        continue
                    }

                    //datasVistas.add(dt)
                    datasVistas.add(dt.getTime())
                    //histIrrigDT.push(el.utc_irrig_ok)
                    //resConvDT = convFromUtc(dtUtcIso, tzName)
                    resConvDT_b = convFromUtc(dt, tzName) // dt utc

                    //console.log('RAW irrig:', el.utc_irrig_ok)
                    //console.log('UTC normalizado:', dt)
                    //console.log('LOCAL irrig:', resConvDT_b)

                    histIrrigDT.push(`${resConvDT_b.dataStr}-${resConvDT_b.hhmm}`) // horario local
                }
                flagRangeIrrig = true // permite usar o hist irrig (confirmada existencia)
            } 

            // li[c] {'received_at': datetime.datetime(2026, 6, 1, 15, 49, 51, 339000), 'rcv_content': {'u_fc': 87.75510204081633, 'conductivity': 435}}

            const maxCE = Math.max(
                ...histRangeRcv.map(el => el.rcv_content.conductivity)
            )
            //console.log('maxCE: ',maxCE)

            let histRangeU = []
            let histCE = []
            let histDT = []
            let dtUtcIso = null
            let resConvDT = null
            let u_fc = null
            let ce = null

            let c = 0
            while (c < histRangeRcv.length) {
                u_fc = Math.round(histRangeRcv[c]['rcv_content'][this.key_a] * 100) / 100
                //console.log(`u_fc (c=${c}): `,u_fc)
                histRangeU.push(u_fc)
                dtUtcIso = histRangeRcv[c]['received_at']
                resConvDT = convFromUtc(dtUtcIso, tzName)
                ce = (histRangeRcv[c]['rcv_content'][this.key_b]*100)/maxCE // ce normalizada ao maximo
                histCE.push(ce)
                //console.log(`resConvDT: `,resConvDT)
                histDT.push(`${resConvDT.dataStr}-${resConvDT.hhmm}`)
                c++
            }

            // sma
            let histMA24 = []
            let histMA3 = []
            
            if (this.flag_show_all) {

                for (let i = 0; i < histRangeU.length; i++) {

                    let ini = Math.max(0, i - 23) // janela de até 24 pontos
                    let soma = 0

                    for (let j = ini; j <= i; j++) {
                        soma += histRangeU[j]
                    }

                    histMA24.push(
                        Math.round((soma / (i - ini + 1)) * 100) / 100
                    )
                }

                for (let i = 0; i < histRangeU.length; i++) {

                    let ini = Math.max(0, i - 2) // janela de até 3 pontos
                    let soma = 0

                    for (let j = ini; j <= i; j++) {
                        soma += histRangeU[j]
                    }

                    histMA3.push(
                        Math.round((soma / (i - ini + 1)) * 100) / 100
                    )
                }
            }

            //console.log('tam histCE: ',histCE.length)

            //const valores = [20,35,45,60,80,100,80,45,32,15,8,78]

            this.series = [
                {
                    name: this.tit_a,
                    type: 'column',
                    data: histRangeU
                }
            ]

            // incluir ce no mapa
            if (this.flag_show_all) {

                this.series.push(
                    {
                        name: this.tit_b,
                        type: 'line',
                        data: histCE
                    }
                )
            }

            // incluir sma no mapa
            if (this.flag_show_all) {

                this.series.push(
                    {
                        name: 'smaX1',
                        type: 'line',
                        data: histMA24
                    }
                )

                this.series.push(
                    {
                        name: 'smaX2',
                        type: 'line',
                        data: histMA3
                    }
                )
            }

            // histIrrigDT
            if (flagRangeIrrig) {

                let eventosScatter = []
                
                for (let i = 0; i < histCE.length; i++) { // ref tamanho vetor
                    eventosScatter.push(null)
                }

                eventosScatter = this.montar_lista_scatter(eventosScatter, histIrrigDT, histDT)

                this.series.push(
                    {
                        name: 'Irrigação',
                        type: 'scatter',
                        data: eventosScatter
                    }
                )
            }

            //this.options.colors = [
            //    '#008FFB', // %FC (coluna)
            //    '#FF0000',  // CE (linha vermelha)
            //    '#000000', // smaX
            //    '#F39C12' // irrigação
            //]

            if (this.flag_show_all) {
    
                this.options.colors = [
                    '#008FFB', // %FC (coluna)
                    '#FF0000',  // CE (linha vermelha)
                    '#000000', // smaX1
                    '#12f3a8', // smaX2
                    '#F39C12' // irrigação
                ]
            }
            else {

                this.options.colors = [
                    '#008FFB', // %FC (coluna)
                    '#F39C12' // irrigação
                ]
            }

            this.options.stroke.width = 2 // -- grossura da linha
            this.options.chart.type = 'bar'
            this.options.dataLabels = {
                enabled: false
            }

            if (this.flag_show_all) {

                // [u, ce, smaX1, smaX2, irrig]
                this.options.markers = { size: [0, 0, 0, 0, 6] }
            }
            else {

                // [u, irrig]
                this.options.markers = { size: [0, 6] }
            }

            // -- eixo x
            //this.options.xaxis.categories = [
            //    '1','2','3','4','5','6','7','8','9','10','11','12'
            //]
            this.options.xaxis.categories = histDT

            //
            //const eventoX = histDT.find(dt => dt.startsWith("22/06/2026-08:24"))

            // LINHA HORIZONTAL INDEPENDENTE DAS SERIES
            if (!this.flag_show_all) { // apenas em u_fc
                
                const alvo = this.target_fc // rcv via props

                this.options.annotations = {
                    yaxis: [
                        {
                            y: alvo,
                            borderColor: '#EA9611',
                            borderWidth: 2,
                            strokeDashArray: 4,
                            label: {
                                text: `${alvo}`,
                                position: 'left',
                                style: {
                                    background: '#EA9611',
                                    color: '#FFF'
                                }
                            }
                        }
                    ]
                }
            }

            // força redraw
            this.chartKey++

            this.flagLoading = false

            this.pageTam()
        },

        pageTam() {

            // -- função chamada pelo BUS dinamicamente, para atualizar o tamanho da exibição do gráfico.

            let widthExibPerc = this.$store.state.widthDinamCA // percentual da exibição | string
            //console.log('(string) widthExibPerc: ',widthExibPerc)
            // -- conv string to float | remover caractere "%"
            widthExibPerc = parseFloat(widthExibPerc.replace('%', ''))
            //console.log('(float) widthExibPerc: ',widthExibPerc)

            const largura = window.innerWidth
            console.log('window.innerWidth (largura): ',largura)

            if (largura > 420) {
                const novaLargura = 0.8*largura // aux calc
                //this.novaAltura = `${0.75*novaLargura}px` // proporção 4:3 para o gráfico expandido.
                this.novaAltura = `${0.4*novaLargura}px` // proporção arbitrária (exibição horizontal)
                this.novaLargura = `${novaLargura*(widthExibPerc/100)}px`

                this.alturaGrafico = Math.round( 0.4 * novaLargura * (widthExibPerc/100) )
                //console.log('[pageTam] IF')
            }
            else {
                //console.log('[pageTam] ELSE')
                this.novaLargura = `280px`; this.alturaGrafico = `200px`;                
            }

            this.chartKey++
        }
    },

    mounted() {
        this.refreshHandler = () => this.pageTam()
        bus.on('refresh-graf', this.refreshHandler)
    },

    beforeUnmount() {
        // -- necessário para evitar multiplos escutadores
        bus.off('refresh-graf', this.refreshHandler)
    },

    created() {

        this.pageTam()
        this.plotTesteBarra()
        this.pageTam() // store com tamanho dinamico ao pressionar o btn menu lateral ?? 02/06/2026
    }
}
</script>
